const Colors = {
  StatusToggleActive: "#0055DD",
  ButtonPrimaryColor: "#357de5",
  White: "white",
  ContainerBackground: "#eff4fc",
  ButtonSecondaryColor: "#dce5f4",
  ButtonDisabledBackground: "#DBDFE5",
  ButtonDisabledColor: "#8B8B8B",
  fontColor: "#082344",
  BLACK: "#000000",
  WHITE: "#FFFFFF",

  DANGER_ICON: "#AA1919",

  Status: {
    UNSCHEDULED: "#A8A8A8",
    SCHEDULED: "#38C39D",
    OVERDUE: "#D9594E",
    DUESOON: "#357DE5",
    FAILED: "#AA1919",
    FAILED_OPERABLE: "#0F772F",
    PASSED: "#097E48",
    N_A: "#F7F7F7",
    STOLEN: "#cfa17c",
    CHECKEDOUT: "#5D94BA",
    AVAILABLE: "#00c1b1",
    RESERVED: "#777777",
    DAMAGED: "#e6564e",
    LOST: "#1a4784",
    DELETED: "#A4515F",
    UNAVAILABLE: "#bb6bd9",
    OUTOFSERVICES: "#bb6bd9",
    CANCELLED: "#e6564e",
    DELETE: "#777",
    TRANSFER_REQUEST: "#3E61F2",
    RETURN_REQUEST: "#f0ad4e",
    RETURN: "#777",
    TRANSFERRED: "#777",
    BOOKED: "#777777",
  },

  // Checklist Report Colors
  BackgroundColor: {
    pass: "#ECFCF3",
    fail: "#FDFBE5",
    na: "#F7F7F7",
    failedOperable: "#FFC352",
    failedLight: "#FFF4F4",
    operableLight: "#FFFAEF",
  },

  TextColor: {
    pass: "#1CA776",
    fail: "#D9594E",
    na: "#9AA0A7",
    operableButRequiresAttention: "#0F772F",
    outOfOrder: "#C90303",
  },

  EXTRACOLORS: {
    WHITE: "#FFFFFF",
    BLACK: "#000000",
    LIGHT_GREY: "#F2F2F2",
    DROPDOWN_PLACEHOLDER: "#777777",
    MUTED_GREY: "#6A6A6A",
  },
};
export default Colors;
